import React, { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { useHistory } from "react-router-dom";
import { postData } from "../../../../services/http.service";
import Constants from "../../../../services/constant";
import { InputTextarea } from "primereact/inputtextarea";

const CreateProviderPrivacyPolicy = () => {
    const toast = useRef(null);
    const history = useHistory();

    const [err, setErr] = useState({});
    const [privacyPolicy, setPrivacyPolicy] = useState({
        type: "PROVIDER",
        heading: null,
        paragraphText: null,
    });

    const handleChangeTerms = (e) => {
        const { name, value } = e.target;
        setPrivacyPolicy((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
        setErr({ ...err, [name]: "" });
    };

    console.log("privacyPolicy", privacyPolicy);

    const validateForm = () => {
        let errors = {};
        if (!privacyPolicy.heading || privacyPolicy.heading.length === 0) {
            errors.seasonName = "heading is required";
        }
        if (!privacyPolicy.paragraphText || privacyPolicy.paragraphText.length === 0) {
            errors.seasonName = "privacy policy is required";
        }

        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = validateForm();
        if (form) {
            postData(Constants.END_POINT.CREATE_PRIVACY_POLICY, privacyPolicy)
                .then((res) => {
                    if (res.success) {
                        console.log("res", res);
                        toast.current.show({ severity: "info", summary: "", detail: "Privacy Policy has been Created Succesfully", life: 3000 });
                        setTimeout(() => history.push("/provider-privacy-policy"), 1000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    return (
        <div className="col-12">
            <div className="card">
                <div className="flex justify-content-between mb-4">
                    <Toast ref={toast} />
                    <h5> Create Privacy Policy</h5>
                </div>

                <div className="p-fluid grid question-div-wrapper mt-4">
                    <div className="field col-12 md:col-12">
                        <span className="p-float-label">
                            <InputText id="heading" name="heading" onChange={handleChangeTerms} value={privacyPolicy.heading} />
                            <label htmlFor="heading">Heading</label>
                        </span>
                    </div>

                    <div className="field col-12 md:col-12">
                        <span className="p-float-label">
                            <InputTextarea id="paragraphText" name="paragraphText" onChange={handleChangeTerms} value={privacyPolicy.paragraphText} rows={5} cols={30} />
                            <label htmlFor="paragraphText">Privacy Policy</label>
                        </span>
                    </div>
                </div>

                <div className="flex justify-content-left mt-3 ">
                    <Button type="button" className="p-button-md p-component" onClick={handleSubmit}>
                        Create Privacy Policy
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CreateProviderPrivacyPolicy;
